/*
 * The slot entry `modules/chat/index.ts` registers for Home (VISUAL.md §7.8, §7.16): the catch-up
 * blocks and the administrator's first door. Imported statically on purpose: a `lazy()` boundary
 * here would make the bundler split the module's shared code into chunks of its own, which costs the
 * shell more than these two files weigh.
 */

import type { HomeSection } from "../../../core/modules/registry.ts"
import { CatchUp } from "./CatchUp.tsx"
import { CreateFirstChannel } from "./CreateFirstChannel.tsx"

export const catchUpSection: HomeSection = {
	id: "chat.catchUp",
	order: 10,
	render: () => <CatchUp />,
	SetupDoor: CreateFirstChannel,
}
